import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { PROFILE_TABS_NAMES } from 'app/modules/user-modules/profile-modules/profile-base/constants/profile-tabs.constants';

export const profilesGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const params = route.queryParams;
    const userStoreService = inject(UserStoreService);
    const routeService = inject(RouteService);

    if (params?.tab == null) {
        return of(true);
    }

    return combineLatest([
        userStoreService.getUser(),
        userStoreService.canSeeAdditionalProfiles$
    ]).pipe(
        filter(([user, canSeeAdditionalProfiles]) => [user, canSeeAdditionalProfiles].every(x => x != null)),
        take(1),
        switchMap(([, canSeeAdditionalProfiles]) => {
            const tab = params.tab === PROFILE_TABS_NAMES.ADDITIONAL_PROFILES && canSeeAdditionalProfiles
                ? PROFILE_TABS_NAMES.ADDITIONAL_PROFILES
                : PROFILE_TABS_NAMES.GENERAL;

            routeService.navigate(RpcRoute.Profile, { state: { tab } }).catch(() => { });

            return of(false);
        }));
};